import styled from "@emotion/styled";
var List = /*#__PURE__*/ styled("ul", {
    target: "eeuzbdw0"
})("display:flex;flex-direction:column;row-gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
export { List };
